import { resolveDiscoveryIconsBucketKey } from '../../services/admin/discoveryIconsApi';
import { loadLocalBotIcon } from './botIconLocalStorage';
import { loadLocalDiscoveryIcons } from './discoveryIconsLocalStorage';

export const BUCKET_BOTS_BASE = 'https://my.edu.gov.il/bucketfiles/bots';

function isDataUrl(url) {
  return typeof url === 'string' && url.startsWith('data:');
}

function normalizeFileName(name) {
  if (typeof name !== 'string') return '';
  const trimmed = name.trim();
  if (!trimmed) return '';
  return trimmed.replace(/\.(svg|png)$/i, '');
}

function extensionFromMimeType(mimeType) {
  if (mimeType === 'image/png') return 'png';
  return 'svg';
}

export function buildBotIconExportUrl(bucketKey, fileName, mimeType) {
  const normalized = normalizeFileName(fileName) || 'icon';
  const ext = extensionFromMimeType(mimeType);
  return `${BUCKET_BOTS_BASE}/${bucketKey}/${normalized}.${ext}`;
}

export function buildDiscoveryIconExportUrl(fileName) {
  const normalized = normalizeFileName(fileName) || 'icon';
  return `${BUCKET_BOTS_BASE}/icons/${normalized}.svg`;
}

export function resolveExportImageUrls(payload, { botName, domainName, draft }) {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const next = JSON.parse(JSON.stringify(payload));
  const bucketKey = resolveDiscoveryIconsBucketKey(botName, draft);

  if (isDataUrl(next.botIconUrl)) {
    const local = loadLocalBotIcon(domainName, botName);
    const fileName = local?.fileName || 'icon';
    const mimeType = local?.mimeType || 'image/svg+xml';
    next.botIconUrl = buildBotIconExportUrl(bucketKey, fileName, mimeType);
  }

  const localIcons = loadLocalDiscoveryIcons(bucketKey);
  const iconByUrl = new Map(localIcons.map((icon) => [icon.url, icon]));

  if (Array.isArray(next.discoveryButton)) {
    next.discoveryButton = next.discoveryButton.map((btn) => {
      if (!btn || !isDataUrl(btn.icon)) {
        return btn;
      }

      const meta = iconByUrl.get(btn.icon);
      const fileName = meta?.fileName || meta?.label || 'icon';
      return {
        ...btn,
        icon: buildDiscoveryIconExportUrl(fileName),
      };
    });
  }

  return next;
}
